import React, {useState} from 'react';
import RadioInput from '@bonprix/pattern-library/templates/input/Radio.jsx';
import InputGroup from '@bonprix/pattern-library/templates/input/Group.jsx';
import {yieldToMain} from '../ArticleOverviewHelper.js';

export default function Ordering({ordering, handleOrderingChange}) {
    const [selectedValue, setSelectedValue] = useState(ordering.find((option) => option.selected).value);

    // TODO: check inp - change seems pretty slow
    const handleOnChange = (value, landmark, name) => {
        yieldToMain(() => setSelectedValue(value));
        handleOrderingChange(value, landmark, name);
    };

    return (
        <div className="ordering-list" test-ref__ordering-list="">
            {ordering.map((option) => {
                const optionChange = () => handleOnChange(option.value, option.landmark, option.name);
                return (
                    <div className="ordering__option" test-ref__ordering-option={option.value} key={option.value}>
                        <InputGroup className="ordering__radio-button">
                            <RadioInput
                                name="orderings"
                                value={option.value}
                                disabled={false}
                                checked={selectedValue === option.value}
                                onChange={optionChange}
                            />
                            <div className="input-group__text">{option.name}</div>
                        </InputGroup>
                    </div>
                );
            })}
        </div>
    );
}
